export default __webpack_public_path__ + "static/media/fNeutral23.6ee54ef8.png";